type LeaderboardItemType = {
	username: string;
	xp: number;
	avatar: string;
	rank?: number;
};

type UserLeaderboardType = Pick<LeaderboardItemType, "xp" | "rank">;

export type FilterChipItem = {
	id: string;
	label: string;
};

export type FilterChipsProps = {
	chips: FilterChipItem[];
	selectedChipId: string;
	handleSelectChip: (chipId: string) => void;
};

export type { LeaderboardItemType, UserLeaderboardType };
